import React from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
} from '@chakra-ui/react';
import { AddIcon } from "@chakra-ui/icons";
import { ModalBox } from '../../components/ModalBox';
import CreateCoupon from '../../components/CreateCoupon';
import { useStripeCoupon } from '../../hooks/useStripeCoupon';
import { LoadingOverlay } from '../../components/LoadingOverlay';
import { PaginatedDataTable } from '../../components/PaginatedDataTable';
import { OnboardingSteps } from '../../components/OnboardingSteps';
import { HelmetComponent } from '../../components/HelmetComponent';

export const StripeCouponPage = () => {
  const {
    addCouponIsOpen,
    addCouponOnOpen,
    addCouponOnClose,
    loading,
    createCoupon,
    coupons,
    updateCoupon,
    deleteStripeCoupon,
    statusCouponIsOpen,
    statusCouponOnOpen,
    coupon,
    setCoupon,
    catalogs,
    onChange,
    selectedItems,
    statusCouponCancel,
    selectProduct,
    removeProduct,
    isUpdate,
    publisher,
    createStripeConnectedAccount,
    createStripeConnectedAccountLink,
    user
  } = useStripeCoupon()

  const couponsColumn = [
    { Header: "Name", accessor: "couponCode" },
    { Header: "Type", accessor: "pricingPlanType" },
    {
      Header: "Status",
      Cell: ({ cell }) => {
        return new Date(cell?.row?.original?.expiryDateUTCFormat) < new Date() ? (
          <Text color="red.500" fontWeight={600}>
            Inactive
          </Text>
        ) : cell?.row?.original?.isActive ? (
          <Text color="green.500" fontWeight={600}>
            Active
          </Text>
        ) : (
          <Text color="red.500" fontWeight={600}>
            Inactive
          </Text>
        )
      },
    },
    { Header: "Times Redeemed", accessor: "timesRedeemed" },
    { Header: "Expires At", accessor: "couponExpiryDate" },
    // { EDIT NOT SUPPORTED BY STRIPE
    //   Header: " ",
    //   Cell: ({ cell }) => {
    //     return cell?.row?.original?.isActive ? (
    //       <Button
    //         variant={"outline"}
    //         colorScheme="blue"
    //         _hover={{ bg: "transparent", color: "blue.800" }}
    //         cursor="pointer"
    //         onClick={() => onEdit(cell?.row?.original)}
    //       >
    //         Edit
    //       </Button>
    //     ) : (
    //       <></>
    //     )
    //   },
    // },
    {
      Header: "  ",
      Cell: ({ cell }) => {
        return new Date(cell?.row?.original?.expiryDateUTCFormat) < new Date() ? (
          <Button
            variant={"solid"}
            colorScheme="red"
            cursor="pointer"
            onClick={() => deleteStripeCoupon(cell.row.original)}
            width="121px"
          >
            Delete
          </Button>

        ) : cell?.row?.original?.isActive ? (
          <Button
            variant={"outline"}
            colorScheme="red"
            cursor="pointer"
            onClick={() => { setCoupon(cell.row.original); statusCouponOnOpen() }}
            width="121px"
          >
            De-Activate
          </Button>
        ) : (
          <Button
            variant={"outline"}
            colorScheme="green"
            cursor="pointer"
            onClick={() => { setCoupon(cell.row.original); statusCouponOnOpen() }}
            width="121px"
          >
            Activate
          </Button>
        )
      },
    },
  ]

  return (
    <>
      <HelmetComponent title={`Coupons - Home - ${user.firstName} ${user.lastName}`}/>
      {
        publisher?.otherInfo?.isOnBoardingCompleted && publisher?.otherInfo?.isStoreSettingComplete ?
          <>
            {loading && <LoadingOverlay />}
            <Box id="no-more-tables">
              <Box>
                <Flex
                  sx={{
                    margin: "20px 0 20px",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button colorScheme="blue" onClick={addCouponOnOpen}>
                    <AddIcon marginRight={"5px"} /> Add Coupon
                  </Button>
                </Flex>
              </Box>
              {
                coupons?.length === 0 ?
                  <Text>No Coupons.</Text> :
                  <PaginatedDataTable
                    columns={couponsColumn}
                    data={coupons}
                    showNumberOfRecords={50}
                  />
              }
              <ModalBox
                title={isUpdate ? "Update Coupon" : "Add Coupon"}
                isOpen={addCouponIsOpen}
                onClose={addCouponOnClose}
                isFooter={true}
                onCancel={addCouponOnClose}
                confirmButtonType={true}
                onConfirm={isUpdate ? (e) => updateCoupon(e, coupon?.isActive) : (e) => createCoupon(e, coupon?.isActive)}
                confirmButtonText={isUpdate ? "Update" : "Create"}
                size="lg"
                description={
                  <CreateCoupon
                    catalogs={catalogs}
                    coupon={coupon}
                    onChange={onChange}
                    selectProduct={selectProduct}
                    removeProduct={removeProduct}
                    selectedItems={selectedItems}
                    isUpdate={isUpdate}
                  />
                }
              ></ModalBox>
              <ModalBox
                title={`${coupon?.isActive ? 'De-activate' : 'Activate'} coupon`}
                description={
                  <>
                    <Text fontSize="lg">
                      Are you sure you want to <Text as="span" color={coupon?.isActive ? "red.500" : "green.500"} fontWeight={600}>{coupon?.isActive ? 'De-activate' : 'Activate'}</Text> coupon?
                    </Text>
                    {
                      coupon?.isActive ?
                        coupon?.pricingPlanType === "Subscription" ? <Text color="red.500"><b>Warning:</b> Existing customer will not be able to redeem the coupon. Customers will be charged full amount from next cycle onwards.</Text>
                          : <Text color="red.500"><b>Warning:</b> New customers will not be able to redeem the coupon</Text>
                        : <></>
                    }
                  </>
                }
                isOpen={statusCouponIsOpen}
                onClose={statusCouponCancel}
                isFooter={true}
                loadingText={coupon?.isActive ? 'De-activating' : 'Activating'}
                onCancel={statusCouponCancel}
                onConfirm={(e) => updateCoupon(e, !coupon?.isActive)}
                cancelButtonText="Cancel"
                confirmButtonText={coupon?.isActive ? 'De-activate' : 'Activate'}
                isDeleteButton={coupon?.isActive}
              ></ModalBox>
            </Box>
          </> :
          <>
            <Text color="orange.600" p={6} >Please finish the onboarding first to get started with coupons.</Text>
            <OnboardingSteps onboarding={publisher?.stripeAccountId ? createStripeConnectedAccountLink : createStripeConnectedAccount} stripeOnboardingUrl={publisher?.stripeOnboardingUrl} publisher={publisher}/>
          </>
      }
    </>
  );
};

export default StripeCouponPage;
